import { Box, CssBaseline, Grid } from "@mui/material";
import Graph from "./Graph";
import SideMenu from "./SideMenuGraph";
import { useEffect, useState } from "react";
import DifferentLength from "./LineChart";
import ComboChart from "./ComboChart";
import MyBarChart from "./BarChart2";
import BasicBars from "./BarGraph";
import MyBarChart2 from "./BarChart3";
import { useUser } from "../Contexts/UserContext";
import { LineChart } from "@mui/x-charts";
import StatsCard from "./StatusCard";
import StatusCardWrapper from "./StatusCardWrapper";
import Dropdown from "./Dropdown";
import ScrollableCard from "./ScrollableCard";
import RepairMaintenanceComponent from "./RepairCard2";
import FeedbackList from "./FeedbackList";
import RepairCard from "./RepairCard";
import UpcomingEvents from "./UpcomingEvents";
import StatsCard2 from "./CustomCard";
import Component from "./Component";
import MaxAttendanceCard from "./AttendanceCard";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const data2 = [
  { day: "day1", value1: 20, value2: 50 },
  { day: "day2", value1: 30, value2: 50 },
  { day: "day3", value1: 10, value2: 60 },
  // Add more data points as needed
];
const data3 = [
  { date: "2024-07-01", text: "Repair A" },
  { date: "2024-07-02", text: "Maintenance B" },
  { date: "2024-07-03", text: "Repair C" },
  { date: "2024-07-01", text: "Repair A" },
  { date: "2024-07-02", text: "Maintenance B" },
  { date: "2024-07-03", text: "Repair C" },
  // Add more data as needed
];
const data4 = [
  { date: "2024-07-01", text: "Great service!" },
  { date: "2024-07-02", text: "Very satisfied with the maintenance." },
  { date: "2024-07-03", text: "Could be better." },
  { date: "2024-07-04", text: "Excellent support!" },
  { date: "2024-07-05", text: "Average experience." },
  { date: "2024-07-06", text: "Not happy with the delay." },
  { date: "2024-07-07", text: "Quick response, appreciated." },
  { date: "2024-07-08", text: "Highly recommend!" },
  // Add more data as needed
];
const options = [
  { value: "option1", label: "Option 1" },
  { value: "option2", label: "Option 2" },
  { value: "option3", label: "Option 3" },
];
const clientList = [
  {
    label: "BHARTI AXA LIFE INSURANCE CO. LTD.",
    value: "11542",
    compCode: "GU-1",
  },
  {
    label: "M/S MAX LIFE INSURANCE CO LTD.",
    value: "1008",
    compCode: "GU-4",
  },
  {
    label: "JONES LANG LASALLE PROPERTY CONSULTANTS (INDIA) PRIVATE LIMITED",
    value: "11554",
    compCode: "GU-1",
  },
  {
    label: "AP SECURITAS PVT. LTD.",
    value: "1353",
    compCode: "GU-4",
  },
  {
    label: "MARKS & SPENCER RELIANCE INDIA PVT LTD.",
    value: "11541",
    compCode: "GU-4",
  },
  {
    label: "AVIVA",
    value: "11613",
    compCode: "GU-1",
  },
];
const DetailGraphPage = () => {
  const [timeInterval, setTimeInterval] = useState("2");
  const [graphData, setGraphData] = useState([]);
  const [context, setContext] = useState("1");
  const [unit, setUnit] = useState("0");
  const [data, setData] = useState([
    { x: 1, y: 10 },
    { x: 2, y: 20 },
    { x: 3, y: 30 },
    // Add more data points as needed
  ]);
  const { user } = useUser();
  const { ClientId, CompCode } = user;
  const [flag, setFlag] = useState();
  const [cardData, setCardData] = useState({
    card1: "1",
    card2: "2",
    card3: "3",
    card4: "4",
    ActiveUsersArr: [],
    Materials: "0",
    TotalUsersArr: [],
  });
  useEffect(() => {
    const fetchIntiData = async () => {
      const response = await fetch(
        `${API_URL}/facility/get-facility-cards-data/1/${CompCode}/${ClientId}/:fromDate/:toDate`
      ).then((res) => res.json());
      await getGraphData(2, "1");

      if (response.success) {
        const {
          ActiveUsers,
          DeepCleaning,
          PestControl,
          TotalSites,
          TotalUsers,
          WashroomCleaning,
          Materials,
        } = response.data;
        let count = 0,
          tUsers = 0;
        TotalUsers.forEach((ele) => {
          tUsers += ele.Count;
        });
        ActiveUsers.forEach((ele) => {
          count += ele.Count;
        });
        setCardData((prev) => ({
          card1: TotalSites,
          card2: count,
          card3: WashroomCleaning,
          card4: DeepCleaning,
          TotalUsers: tUsers,
          ActiveUsersArr: ActiveUsers,
          Materials: Materials,
          TotalUsersArr: TotalUsers,
        }));
      } else {
        alert("Error!");
      }
    };
    fetchIntiData();
  }, [ClientId]);
  const getGraphData = async (interval, context) => {
    let res;
    if (ClientId == "11542") {
      res = await fetch(
        `${API_URL}/facility/GetBhartiAxaGraphData/${
          interval - 1
        }/GU-1/11542/${unit}/1`
      ).then((res) => res.json());
    } else if (context == "8") {
      // washroom cleaning
      res = await fetch(
        `${API_URL}/facility/GetWashRoomGraphData/${
          interval - 1
        }/GU-4/1008/unitCode`
      ).then((res) => res.json());
    } else {
      if (unit == "0") {
        res = await fetch(
          `${API_URL}/facility/GetGraphData/${interval}/${CompCode}/${ClientId}/UNTAPS/${context}`
        ).then((res) => res.json());
      } else {
        console.log(interval);
        res = await fetch(
          `${API_URL}/facility/GetGraphData2/${interval}/${CompCode}/${ClientId}/${unit}/${context}`
        ).then((res) => res.json());
        console.log(res);
      }
    }

    if (res.success) {
      setGraphData(res.data);
    } else {
      alert("Unable to fetch data :( ");
      console.log(res);
    }
  };
  const handleTimeIntervalChange = (interval) => {
    setTimeInterval(interval);
    getGraphData(interval, context);
  };

  const handleContextChange = (ctx) => {
    setContext(ctx);
    getGraphData(timeInterval, ctx);
  };
  const handleFlag = () => {
    if (timeInterval == "day") {
      return 0;
    } else if (timeInterval == "week") {
      return 1;
    } else {
      return 2;
    }
  };
  const handleUnitChange = (val) => {
    console.log(val);
    setUnit(val);
  };
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <CssBaseline />
      <Grid container mt={2} height="150px">
        <Grid
          item
          sx={{
            width: "250px",
            height: "100%",
            padding: "10px",
            bgcolor: "#eee",
          }}
        >
          <Dropdown options={clientList} placeholder="Select Client" />
        </Grid>
        <Grid item sx={{ flex: 1, paddingLeft: "20px" }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={3}>
              <StatsCard
                title="Total Sites"
                subtitle="Active Sites"
                number={`${cardData.card1}`}
                classNames="c1"
                activeBtn={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <MaxAttendanceCard
                title="Attendance (D)"
                subtitle="Active Users"
                number={`${cardData.card2}/${cardData.TotalUsers}`}
                arr={cardData.ActiveUsersArr}
                arr2={cardData.TotalUsersArr}
                classNames="c2"
                activeBtn={true}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6} md={3}>
              <StatsCard2
                title="Attendance (D)"
                subtitle="Active Users"
                number={`${cardData.card2}/100`}
                classNames="Attendance"
                activeBtn={true}
              />
            </Grid> */}
            {/* <Grid item xs={12} sm={6} md={3}>
              <StatsCard
                title="Attendance (D)"
                subtitle="Active Users"
                number={`${cardData.card2}/${cardData.TotalUsers}`}
                classNames="c2"
                activeBtn={true}
              />
            </Grid> */}
            {/* <Grid item xs={12} sm={6} md={3}>
              <StatsCard
                title="Washroom (D)"
                subtitle="Reports Submitted"
                number={`${cardData.card3}`}
                classNames="c2"
                // activeBtn={true}
              />
            </Grid> */}
            <Grid item xs={12} sm={6} md={3}>
              {/* <StatsCard2
                title="Attendance (D)"
                subtitle="Active Users"
                number={`${cardData.card2}`}
                number2={`${cardData.TotalUsers}`}
                classNames="Attendance"
                activeBtn={true}
              /> */}
              {/* <MaxAttendanceCard
                title="Attendance (D)"
                subtitle="Active Users"
                number={`${cardData.ActiveUsers}/${cardData.TotalUsers}`}
                arr={cardData.ActiveUsersArr}
                classNames="c2"
                activeBtn={true}
              /> */}
              <StatsCard
                title="Materials (M)"
                subtitle="Orders"
                // number={cardData.PestControl}
                number={`${cardData.Materials}/${cardData.card1}`}
                classNames="material"
                activeBtn={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <StatsCard2
                title="Washroom (D)"
                subtitle="Reports Submitted"
                number={`${cardData.card3}`}
                number2={`${cardData.card1}`}
                classNames="Washroom"
                // activeBtn={true}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <Box sx={{ width: "250px" }}>
          <SideMenu
            timeInterval={timeInterval}
            context={context}
            onTimeIntervalChange={handleTimeIntervalChange}
            onContextChange={handleContextChange}
            onFilterChange={handleUnitChange}
          />
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            paddingTop: 15,
            border: "2px solid black",
            width: "60%",
          }}
        >
          {/* <Graph data={data} /> */}
          {/* <ComboChart data={data2} /> */}
          {/* <DifferentLength /> */}
          {ClientId == "11542" && context === "1" ? (
            <MyBarChart2
              context={context}
              timeInterval={timeInterval}
              rawData={graphData}
            />
          ) : (
            // <MyBarChart data={graphData} />
            <MyBarChart
              context={context}
              timeInterval={timeInterval}
              rawData={graphData}
            />
          )}
          {/* <BasicBars /> */}
          {/* <MyBarChart flag={handleFlag()} /> */}
          {/* <DifferentLength /> */}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "baseline",
          padding: "20px",
        }}
      >
        <Component />
        {/* <Box width="30%">
          <FeedbackList data={data3} />
        </Box>
        <Box width="30%">
          <UpcomingEvents />
        </Box>
        <Box width="30%">
          <RepairCard feedbacks={[]} />
        </Box> */}
      </Box>
    </Box>
  );
};
export default DetailGraphPage;
